<app-burger-menu class="full-height burger-menu">
    <!-- <app-toolbar>
    </app-toolbar> -->
    <router-outlet></router-outlet>
</app-burger-menu>